export default {
      id: "calculator-bold-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite.svg#calculator-bold",
      toString: function () {
        return this.url;
      }
    }